import { render, staticRenderFns } from "./ReporteRendimiento.vue?vue&type=template&id=506b0e28&"
import script from "./ReporteRendimiento.vue?vue&type=script&lang=js&"
export * from "./ReporteRendimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports